var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "locationline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.594,
    height: 43.511,
    viewBox: "0 0 30.594 43.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M91.3,0A15.3,15.3,0,0,0,78.283,23.34L90.426,42.908a1.275,1.275,0,0,0,1.083.6h.01a1.274,1.274,0,0,0,1.084-.62l11.833-19.757A15.3,15.3,0,0,0,91.3,0Zm10.951,21.825L91.49,39.787,80.45,22a12.756,12.756,0,1,1,21.8-.172Z",
    transform: "translate(-76 0)",
    fill: "#373737"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(7.648 7.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M173.648,90a7.648,7.648,0,1,0,7.648,7.648A7.657,7.657,0,0,0,173.648,90Zm0,12.764a5.116,5.116,0,1,1,5.107-5.116A5.12,5.12,0,0,1,173.648,102.764Z",
    transform: "translate(-166 -90)",
    fill: "#373737"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationline);
export default __webpack_public_path__ + "static/media/locationline.f0104a53bacf20f12ebf1cb334ed694a.svg";
export { ForwardRef as ReactComponent };